<template>
  <p class="demo__title">Smartphone (Esto es un demo que simula el flujo)</p>
</template>

<script>
export default {
  name: 'DemoHeaderText'
};
</script>

<style lang="scss">
  
</style>



// WEBPACK FOOTER //
// src/components/DemoHeaderText.vue